<template>
  <section class="fairy-display" @scroll="handleScroll" ref="container">
    <img class="banner" :src="bannerImg" @load="bannerLoad">
    <div class="nav-wrap">
      <div class="nav-btn-con" :class="{'nav-btn-con-fixed': fixNavTop}" ref="navBtnCon">
        <div class="nav-top">
          <a class="nav-btn nav-btn-box nav-btn-all-box" :class="{
              'nav-btn-active': ids.indexOf(activeId) > -1,
              'nav-btn-active-box': ids.indexOf(activeId) > -1,
            }" v-for="ids in topNavs" :key="ids[0]" :data-id="ids[0]" @click="handleNavClick">
          </a>
        </div>
        <div class="nav-sub">
          <a class="nav-btn nav-btn-all-box" :class="id === activeId ? 'nav-btn-active nav-btn-active-box' : ''"
            v-for="id in subNavs" :key="id" :data-id="id" @click="handleNavClick">
          </a>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 图片展示 -->
      <div class="img-list-wrap" @click="handleClick">
        <div class="img-con" ref="imgCon" v-for="(img, index) in pictures" :key="index">
          <img :ref="img.id" :src="img.src" :data-id="img.id" />
        </div>
        <img class="img-con" :src="authorityImg" />
      </div>
    </div>
  </section>
</template>
<script>
// 仙女照承接页
import minirouterMethod from '@/mixins/minirouterMethod.js'
const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'
const AN_RAN_SINGLE = IS_PROD ? '8627' : '8627'
const XING_YUAN_SINGLE = IS_PROD ? '8630' : '8630'
const XIN_YUE_SINGLE = IS_PROD ? '8628' : '8628'
const YUN_ROU_SINGLE = IS_PROD ? '8629' : '8629'

const AN_RAN_DOUBLE = IS_PROD ? '8632' : '8632'
const XING_YUAN_DOUBLE = IS_PROD ? '8633' : '8633'
const XIN_YUE_DOUBLE = IS_PROD ? '8634' : '8634'
const YUN_ROU_DOUBLE = IS_PROD ? '8635' : '8635'

const SUB_NAVS_SINGLE = [AN_RAN_SINGLE, XING_YUAN_SINGLE, XIN_YUE_SINGLE, YUN_ROU_SINGLE]
const SUB_NAVS_DOUBLE = [AN_RAN_DOUBLE, XING_YUAN_DOUBLE, XIN_YUE_DOUBLE, YUN_ROU_DOUBLE]
export default {
  name: 'yunfuThemePage',
  mixins: [minirouterMethod],
  data() {
    return {
      activeId: null,
      bannerImg: require('./assets/banner.jpg'),
      authorityImg: require('./assets/11.jpg'),
      navToTop: 0,
      topNavs: [SUB_NAVS_SINGLE, SUB_NAVS_DOUBLE],
      pictures: [
        {
          id: AN_RAN_SINGLE,
          src: require('./assets/3.jpg'),
          name: '安然'
        },
        {
          id: XING_YUAN_SINGLE,
          src: require('./assets/4.jpg'),
          name: '星愿'
        },
        {
          id: XIN_YUE_SINGLE,
          src: require('./assets/5.jpg'),
          name: '欣悦'
        },
        {
          id: YUN_ROU_SINGLE,
          src: require('./assets/6.jpg'),
          name: '云柔'
        },
        {
          id: AN_RAN_DOUBLE,
          src: require('./assets/7.jpg'),
          name: '安然'
        },
        {
          id: XING_YUAN_DOUBLE,
          src: require('./assets/8.jpg'),
          name: '星愿'
        },
        {
          id: XIN_YUE_DOUBLE,
          src: require('./assets/9.jpg'),
          name: '欣悦'
        },
        {
          id: YUN_ROU_DOUBLE,
          src: require('./assets/10.jpg'),
          name: '云柔'
        },
      ],
      fixNavTop: false
    }
  },
  computed: {
    subNavs() {
      return SUB_NAVS_SINGLE.indexOf(this.activeId) > -1 ? SUB_NAVS_SINGLE : SUB_NAVS_DOUBLE;
    }
  },
  methods: {
    async bannerLoad() {
      await this.$nextTick()
      this.navToTop = this.$refs.navBtnCon?.offsetTop || 0;
    },
    // 点击切换nav
    async handleNavClick(e) {
      let prodId = e.target.dataset.id
      if (!prodId) return
      this.activeId = String(prodId)
      let diff = null;
      switch (prodId) {
      case AN_RAN_SINGLE:
        diff = 180
        break
      case AN_RAN_DOUBLE:
        diff = 200
        break
      default:
        diff = 20;
      }

      await this.$nextTick()
      this.$refs['container'].scrollTop = this.$refs[this.activeId][0].offsetTop - this.$refs.navBtnCon.offsetHeight + diff
    },
    // 监听点击事件并跳转到对应产品
    handleClick(e) {
      const targetId = e.target.dataset.id;
      if (!targetId) {
        return;
      }
      let prodId = SUB_NAVS_SINGLE.includes(targetId) ? '28431' : '28434'
      this.miniRouterLink('gold', prodId)
    },
    // 监听页面滚动
    handleScroll(e) {
      let scrolledDistance = e.target.scrollTop + window.innerHeight
      this.fixNavTop = e.target.scrollTop > this.navToTop - 10
      let imgCon = this.$refs.imgCon || [];
      if (imgCon.length === 0) {
        return;
      }
      let pictures = this.pictures
      if (scrolledDistance < imgCon[0].offsetTop) {
        this.activeId = pictures[0].id
        return
      }
      for (let i = 0; i < imgCon.length - 1; i++) {
        if (scrolledDistance > imgCon[i].offsetTop + 400 && scrolledDistance < imgCon[i + 1].offsetTop + 400) {
          this.activeId = pictures[i].id
        }
      }
      if (scrolledDistance > imgCon[imgCon.length - 1].offsetTop + 400) {
        this.activeId = pictures[imgCon.length - 1].id
      }
    }
  },
  mounted() {
    this.activeId = this.pictures[0].id
  }
}
</script>
<style lang="less" scoped>
  @import "./index.less";
</style>
